import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LeagueDetailsComponent } from './league-details.component';
import { SplitVideoboardComponent } from './split-videoboard/split-videoboard.component';

const routes: Routes = [
    {
        path: 'teams/:id',
        loadChildren: () => import('../..//my-teams/team-details/team-details.module').then(m => m.TeamDetailsModule)
    },
    {
        path: '',
        component: LeagueDetailsComponent
    },
    {
        path: 'stream-view/:theme',
        component: SplitVideoboardComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LeagueDetailsRoutingModule { }
